export const guestStartModalStyles = {
  'abyss-modal-content-container': {
    width: '720px',
    padding: '16px 0px 0px 0px',
    '& .abyss-modal-content-title': {
      fontSize: '28px',
      fontWeight: '700',
      padding: '0px 16px 16px 16px',
    },
  },
  'abyss-modal-header-container': {
    padding: '0',
  },
};

export const guestStartModalInfoStyles = {
  '&.abyss-modal-section-root': {
    fontSize: '16px',
    fontWeight: '400',
    padding: '0px 16px 16px 16px',
  },
};
